import { render, staticRenderFns } from "./PleitoDespesasParceiro.vue?vue&type=template&id=037fca63"
import script from "./PleitoDespesasParceiro.vue?vue&type=script&lang=js"
export * from "./PleitoDespesasParceiro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports